import React, { useState, useEffect } from 'react'
import LandingWrapper from './LandingWrapper'
import { Helmet } from "react-helmet";
import { TryModal } from './Modal'
import Fade from 'react-reveal/Fade';
import { GetReferencement } from './Admin/Main/services'
import './styles.css'

const PAGE_NAME = 'PRODUITS'
export default function LandingProduct() {
  const [referencement, setReferencement] = useState(null)

  useEffect(() => {
    GetReferencement().then(source => setReferencement(source))
  }, [])

  return (
    <LandingWrapper>
      <Helmet>
        <title>
          {
            referencement ?
              referencement.find((dt) => dt.pageCible === PAGE_NAME ) ? referencement.find((dt) => dt.pageCible === PAGE_NAME ).siteTitle : "DKBSign"
              : "DKBSign"
          }
        </title>
        <meta
          name="description"
          content={
            referencement ?
              referencement.find((dt) => dt.pageCible === PAGE_NAME ) ? referencement.find((dt) => dt.pageCible === PAGE_NAME ).meta_description : ""
              : ""
          }
        />

        <meta
          name="keywords"
          content={
            referencement ?
              referencement.find((dt) => dt.pageCible === PAGE_NAME ) ? referencement.find((dt) => dt.pageCible === PAGE_NAME ).meta_keywords : ""
              : ""
          }
        />

        <meta name="robots" content={
          referencement ?
            referencement.find((dt) => dt.pageCible === PAGE_NAME ) ? referencement.find((dt) => dt.pageCible === PAGE_NAME ).meta_robots : ""
            : ""
        }
        />
        <meta name="category" content={
          referencement ?
            referencement.find((dt) => dt.pageCible === PAGE_NAME ) ? referencement.find((dt) => dt.pageCible === PAGE_NAME ).meta_category : ""
            : ""
        }
        />

        <meta name="identifier-url" content={
          referencement ?
            referencement.find((dt) => dt.pageCible === PAGE_NAME ) ? referencement.find((dt) => dt.pageCible === PAGE_NAME ).meta_identifier_url : ""
            : ""
        }
        />

        <meta name="reply-to" content={
          referencement ?
            referencement.find((dt) => dt.pageCible === PAGE_NAME ) ? referencement.find((dt) => dt.pageCible === PAGE_NAME ).meta_reply_to : ""
            : ""
        }
        />
      </Helmet>
      <Header />
      <SwitchToNumerique />
      <Entreprises />
      <StrongPoint />
      <FAQArea />
    </LandingWrapper>
  )
}

const Header = () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <React.Fragment>
      { showModal && <TryModal showModal={showModal} setShowModal={setShowModal} /> }
      <div className="landing-product__body-content">
        <div style={{ right: '8%' }} className='flip-header'>
          <Fade duration={4000} left>
            <div className="landing-product__body-content-left">
              <div className="landing-product__body-content-left-title">
                <h1>Apposez votre signature</h1>
                <h3>en un clique</h3>
                <p>
                  Passez au tout numérique pour vos signatures de documents. <br />
                  Grâce à nos solutions de signature électronique, <br />
                  les entreprises et les particuliers peuvent automatiser <br />
                  leurs flux de données et signer n'importe quel document, <br />
                  en tout lieu, à tout moment et sur tous les appareils. <br />
                  Pour tous vos processus B2C, B2B ou même internes, <br />
                  nous avons la solution fluide et rapide. Passez du papier <br />
                  et des tâches manuelles à la dématérialisation!<br />
                </p>
              </div>
              <div 
                onClick={() => setShowModal(true)}
                className="landing-product__body-content-left-button">
                DEMANDER UNE DEMO
              </div>
            </div>
            <div className="landing-home__body-content-right">
              <img src="./assets/media/home_icon/im-solution.png" className='landing-product__body-content-right_img_signataire' alt="landing-home__body-content-right_img_signataire" />
            </div>
          </Fade>
        </div>
      </div>
    </React.Fragment>
  )
}

const FAQArea = () => {

  const [items] = useState([
    {
      id: 1,
      title: '1. Qu\'est-ce que la signature électronique ?',
      description:
        <>
          <p>
            La signature électronique (dite aussi signature numérique) est un processus, utilisant des mécanismes de cryptologie, permettant de garantir l'intégrité d'un document électronique et d'en authentifier l'auteur, par analogie avec la signature manuscrite d'un document papier. Les signatures électroniques ont une valeur légale dans la majorité des cas dans la majorité des pays du monde entier. En Europe c’est le règlement eIDAS qui règlemente les différents types de signatures et leur usage. De plus en plus de sociétés dématérialisent leurs parcours de signature, par exemple, leurs contrats commerciaux, leurs contrats fournisseurs, documents RH, validations internes...
          </p>
        </>
    },
    {
      id: 2,
      title: '2. Les signatures électroniques que vous proposez sont-elles basées sur des certificats numériques ?',
      description:
        <>
          <p>
            Toutes nos transactions sont chiffrées et sécurisées grâce aux certificats électroniques. Il s’agit de certificats organisme pour les signatures dites « simples » et de certificats personnels pour les signatures dites « avancées » (AES) ou « qualifiées » (QES). Une authentification (OTP/SMS, code d’identification ou login) est réalisée pour chaque signataire. Une fois le signataire authentifié, l’infrastructure de signature génère une clé privée dans un dispositif matériel sécurisé (HSM) et un certificat au nom du signataire. Ce certificat personnel à usage unique est alors utilisé pour réaliser la signature cryptographique insérée dans le document. Il est important de comprendre que la solution DKBSign, à différence d’autres solutions concurrentes, ne nécessite pas que les signataires possèdent au préalable un certificat de signature. Chez nous c’est le système qui lui crée à la volée, de façon complètement transparente pour l’utilisateur.
          </p>
        </>
    },
    {
      id: 3,
      title: '3. Comment fonctionne la signature cloud ?',
      description:
        <>
          <p>Beaucoup de personnes encore aujourd’hui associent la signature électronique à des clés USB. Historiquement il fallait avoir une clé de signature pour signer électroniquement un document à partir de son PC. Aujourd’hui, grâce aux avancées de la technologie et du monde du cloud, n’importe qui peut signer un document en tout lieu, à tout moment, sur tous les appareils grâce à des solution cloud comme DKBSign Signature ou DKBSign Protect&Sign. C’est vraiment plus simple pour le signataire mais aussi pour la personne qui envoie le document à signer car elle ne doit plus se soucier de savoir si son signataire est en possession d’une clé de signature ou pas. Au cas où votre cas d’usage requiert de signer par clés USB sachez que DKBSign commercialise aussi une gamme complète de clés de signature électronique – il s’agit de notre offre K.Sign.</p>
        </>
    },
    {
      id: 4,
      title: '4. Proposez-vous plusieurs offres de signature numérique ?',
      description:
        <>
          <p>
            Les usages de cette technologie sont tellement divers et variés que nous proposons plusieurs offres pour mieux répondre aux différents besoins. Nos offres s’articulent autour de deux gammes de produits, DKBSign Signature et Protect & Sign. Avec son interface utilisateur simple, sa grande flexibilité dans les workflows gérés et le respect des contraintes européennes, DKBSign Signature est notre offre phare. C'est d'ailleurs la solution de signature électronique la plus vendue au monde ! DKBSign Appliance est une offre de cloud hybride. Vous pouvez choisir d'héberger les certificats de signature dans votre propre datacenter derrière vos firewalls. Protect & Sign est une offre de signature prévue pour de gros déploiements, plutôt dans le monde BtoC. Protect & Sign Invoice est une offre conçue pour les besoins de dématérialisation de factures en France. K.Sign est une offre de certificats RGS (software ou hardware) utilisables entre autres pour des besoins de signature en local sur votre PC.
          </p>
        </>
    },
    {
      id: 5,
      title: '5.  Comment les destinataires signent-ils électroniquement les documents avec DKBSign ?',
      description:
        <>
          <p>Le destinataire d'un document n'a pas besoin d'être client DKBSign ou d'installer un quelconque élément sur son appareil. Il lui suffit de cliquer sur le lien pour ouvrir les documents proposés. Des balises et des instructions simples guident l'utilisateur tout au long du processus de signature.</p>
        </>
    },
    {
      id: 6,
      title: '6.  Qu\'est-ce que le DTM  ?',
      description:
        <>
          <p>La gestion de transactions numériques (DTM) est un ensemble de services en ligne qui permet aux entreprises de gérer numériquement les transactions basées sur des documents. Le DTM, basé sur une norme appelée xDTM, rationalise les opérations et améliore le retour sur investissement. DKBSign est adepte de la norme xDTM sur la gestion des transactions dans un monde ouvert numériquement où les clients et les entreprises peuvent réaliser des transactions en ligne sans risquer d'être confrontés à des technologies non compatibles.</p>
        </>
    },
    {
      id: 7,
      title: '7. Les signatures de DKBSign sont-elles sécurisées ?',
      description:
        <>
          <p>DKBSign respecte les meilleures pratiques existantes concernant la sécurisation de vos données et de vos transactions. Chaque signature numérique est unique, documentable, chiffrée et infalsifiable. DKBSign garantit la confidentialité de toutes les transactions et la protection des données clients.</p>
        </>
    },
    {
      id: 8,
      title: '8.  Puis-je signer électroniquement sur mon smartphone ou ma tablette ?',
      description:
        <>
          <p>Grâce à l'application mobile de DKBSign, vous pouvez préparer et envoyer des documents à signer, les signer vous-même ou les faire signer en face-à-face. Vous pouvez suivre en temps réel le statut de vos documents sur votre ordinateur, smartphone ou tablette. Les apps mobiles de DKBSign sont d'ailleurs disponibles dans le monde entier sur l'iOS App Store d'Apple, Google Play, Windows Phone et les boutiques Windows. Téléchargez votre apps dès maintenant.</p>
        </>
    },
    {
      id: 9,
      title: '9. Les signatures numériques de DKBSign ont-elles une valeur légale ?',
      description:
        <>
          <p>Nous proposons un service certifié, qui répond à un cadre juridique éprouvé et conforme aux plus hautes normes et standards Européen. Nos signatures avec certificat respectent les exigences de la « Signature Avancée » et même de la « Signature Qualifiée » du règlement européen eIDAS.</p>
        </>
    },
    {
      id: 10,
      title: '10. Comment DKBSign facture-t-elle les utilisateurs ?',
      description:
        <>
          <p>La signature de documents est toujours gratuite. DKBSign facture en revanche l'utilisation de fonctions comme la signature d'autres personnes, la personnalisation graphique, l'authentification du signataire, etc. Voir nos forfaits et fonctionnalités pour l’offre DKBSign Signature. Nous contacter pour les autres offres.</p>
        </>
    },
    {
      id: 11,
      title: '11. Quelle est la position de DKBSign vis-à-vis des lois européennes comme le transfert de données hors EU ?',
      description:
        <>
          <p>L’activité en France et en Europe est gérée par la société DKBSign France. Nous sommes une société de droit français. Nos activités et infrastructures respectent la législation française et européenne sur la protection des données personnelles, et bénéficient des agréments de Prestataire de Service de Confiance Qualifié.</p>
        </>
    },
    {
      id: 12,
      title: '12. Les signatures électroniques de DKBSign sont-elles disponibles et valides en dehors de France ?',
      description:
        <>
          <p>DKBSign constitue la norme mondiale en matière de gestion des transactions numériques avec plus de 85 millions d'utilisateurs dans 188 pays répartis dans le monde entier. Vous pouvez signer vos documents là où vous conduisent vos activités, tout en étant sûrs que vos signatures sont légales et valides dans le temps.</p>
        </>
    }
  ])

  return (
    <div className="landing-tarif__faq-area">
      <Fade duration={3000} left>
        <div className="landing-tarif__faq-area-left">
          <div className="landing-tarif__faq-area-left-title">
            Foire <br />
            Aux <br />
            Questions
          </div>
        </div>
      </Fade>

      <Fade duration={5000} right>
        <div className="landing-tarif__faq-area-right">
          {items.map((item) => <Accordion key={item.id} items={item} />)}
        </div>
      </Fade>
    </div>
  )
}

const SwitchToNumerique = () => {
  return (
    <div className="landing-product__switch-to-numerique">
      <Fade duration={3000} left>
        <div className="landing-product__switch-to-numerique_left-content">
          <img className='landing-product__switch-to-numerique_left-content-img' src="./assets/media/home_icon/Signature-illustration-removebg-preview.png" alt="image" />
        </div>
      </Fade>

      <Fade duration={3000} right>
        <div className="landing-product__switch-to-numerique_right-content">
          <div className="landing-product__switch-to-numerique_right-content-title">
            Passer au tout numérique pour <br />
            vos signatures, c'est legal
          </div>
          <div className="landing-product__switch-to-numerique_right-content-text">
            Faire signer les approbations, les accords et les contrats en mettant <br />
            en place des processus intégralement en ligne n'est pas seulement <br />
            un gain de temps et d'argent mais c'est aussi 100% légal en France et <br />
            dans le monde entier. Nos offres sont certifiées et répondent à <br />
            un cadre juridique éprouvé. Nos signatures respectent les exigences de la
            « Signature Avancée » et de la « Signature Qualifiée » du <br />
            règlement européen eIDAS.

            <li>Plus d'info sur elDAS</li>
            <li>Plus d'info sur la valeur juridique des signatures électroniques.</li>
          </div>
        </div>
      </Fade>
    </div>
  )
}

const Entreprises = () => {
  return (
    <div className="landing-product__entreprises">

      <div className="landing-product__entreprises-list">
        <img className='landing-product__entreprises-list-img' src="./assets/media/home_icon/company.png" alt="company" />
        <img className='landing-product__entreprises-list-img' src="./assets/media/home_icon/bank.png" alt="bank" />
        <img className='landing-product__entreprises-list-img' src="./assets/media/home_icon/market.png" alt="market" />
      </div>

      <Fade duration={5000} left>
        <div className="landing-product__entreprises-text">
          Notre solution est utilisée par les entreprises de toutes tailles et dans <br />
          tous les secteurs d'activités. <br />
          Les fonctionnalités intuitives et innovantes répondent à vos besoins de <br />
          dématérialisation, des plus simples au plus avancés <br />
        </div>
      </Fade>
    </div>
  )
}

const StrongPoint = () => {
  return (
    <div className="landing-product__strong-point">
      <Fade duration={4000} left>
        <div className="landing-product__strong-point-title">
          Signature electronique: les points <br />
          forts de DKBSign
        </div>
      </Fade>

      <div className="landing-product__strong-point-list">
        <div className="landing-product__strong-point-list-item">
          <div className="landing-product__strong-point-list-item-title">
            <img className='landing-product__strong-point-list-item-title-img' src="./assets/media/home_icon/harmer.png" alt="strong_point_1" />
            <p>Signatures a valeur légale</p>
          </div>
          <div className="landing-product__strong-point-list-item-text">
            La signature DKBSign est 100% légale en Côte d'Ivoire. Nos signatures électroniques sont conformes la loi N°2013-546 du 30 juillet 2013 relative aux transactions électroniques et du décret d'application
            N° 2014-106 du 12 mars 2014 fixant les conditions d'établissement et de conservation de l'écrit et de la signature sous forme électronique, ont une valeur probante pour toutes les transactions commerciales en Côte d'Ivoire, en Afrique et dans le monde entier
          </div>
        </div>

        <div className="landing-product__strong-point-list-item">
          <div className="landing-product__strong-point-list-item-title">
            <img className='landing-product__strong-point-list-item-title-img' src="./assets/media/home_icon/confirm.png" alt="strong_point_1" />
            <p>Toujours disponible</p>
          </div>
          <div className="landing-product__strong-point-list-item-text">
            L'architecture système de DKBSign garantit une disponibilité totale de nos sites actifs avec réplication en temps réel, supprimant ainsi totalement la nécessité d'interruption de service pour maintenance. Ce système de redondance offre des performances élevées 24 heures sur 24, y compris lors des pics d'utilisation.
          </div>
        </div>

        <div className="landing-product__strong-point-list-item">
          <div className="landing-product__strong-point-list-item-title">
            <img className='landing-product__strong-point-list-item-title-img' src="./assets/media/home_icon/offre.png" alt="strong_point_1" />
            <p>Offre globale</p>
          </div>
          <div className="landing-product__strong-point-list-item-text">
            les avantages de nos processus d'accords numériques sont accessibles depuis le monde entier. Acteur global engagé localement, nous respectons les différentes législations et obligations nationales.
            Nous nous engageons
            notamment à ce que les documents de nos clients Afrciains soient gérés en
            Afirque.
          </div>
        </div>

        <div className="landing-product__strong-point-list-item">
          <div className="landing-product__strong-point-list-item-title">
            <img className='landing-product__strong-point-list-item-title-img' src="./assets/media/home_icon/choice.png" alt="strong_point_1" />
            <p>Vous avez le choix</p>
          </div>
          <div className="landing-product__strong-point-list-item-text">
            Chaque entreprise étant différente, nous vous garantissons des offres flexibles. Nous proposons
            plusieurs offres de signature électronique, personnalisables selon vos besoins métier. Nos
            API permettent aussi aux développeurs
            d'intégrer la signature numérique dans leurs
            applicatifs métiers.
          </div>
        </div>
      </div>
    </div>
  )
}

const Accordion = ({ items }) => {
  const [show, setShow] = useState(false)

  return (
    <React.Fragment>
      <div className="accordion">
        <div
          onClick={() => setShow(!show)}
          className="accordion-header"
        >
          <div className="accordion-header-title">{items.title}</div>
          <div className="accordion-header-icon">{show ? '-' : '+'}</div>
        </div>
        <div className={show ? 'accordion-body body-display' : 'accordion-body'}>
          <div className="accordion-body-description">{items.description}</div>
        </div>
      </div>
    </React.Fragment>
  )
}